import { a as attr } from './vivid-element.js';

var __defProp = Object.defineProperty;
var __decorateClass = (decorators, target, key, kind) => {
  var result = void 0 ;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (decorator(target, key, result) ) || result;
  if (result) __defProp(target, key, result);
  return result;
};
const WithErrorText = (Base) => {
  class ElementWithErrorText extends Base {
    /**
     * @internal
     */
    errorTextChanged(_, newErrorText) {
      if (newErrorText) {
        this.#forceCustomError(newErrorText);
      } else {
        this.#clearCustomErrorAndRevalidate();
      }
    }
    #blockValidateCalls = false;
    #originalValidateFn;
    constructor(...args) {
      super(...args);
      this.#originalValidateFn = this.validate;
      this.validate = () => {
        if (!this.#blockValidateCalls) this.#originalValidateFn();
      };
    }
    #forceCustomError(errorMessage) {
      this.setValidity(
        { customError: true },
        errorMessage,
        this.control
      );
      this.errorValidationMessage = errorMessage;
      this.#blockValidateCalls = true;
    }
    #clearCustomErrorAndRevalidate() {
      this.setValidity({}, "", this.control);
      this.#blockValidateCalls = false;
      this.validate();
    }
  }
  __decorateClass([
    attr({ attribute: "error-text" })
  ], ElementWithErrorText.prototype, "errorText");
  return ElementWithErrorText;
};

export { WithErrorText as W };
